export var filesContainer = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2em'
};
export var uploadCard = function uploadCard(theme) {
  return {
    padding: '1.6em',
    border: "1px solid ".concat(theme.gray150),
    backgroundColor: theme.gray50,
    '& .upload-fields': {
      display: 'flex',
      gap: '1em',
      marginBottom: '1.2em',
      '@media (max-width: 576px)': {
        flexDirection: 'column'
      }
    },
    '& .upload-description': {
      flex: '1 1 200px',
      minWidth: 0
    },
    '& .upload-dropzone': {
      flex: '1 1 200px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '1.2em 1em',
      border: "2px dashed ".concat(theme.gray200),
      backgroundColor: theme.white,
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      textAlign: 'center',
      minHeight: '4.4rem',
      marginTop: '2.1em',
      '&:hover': {
        borderColor: theme.primary,
        backgroundColor: theme.primaryLight
      },
      '& > i': {
        fontSize: '2rem',
        color: theme.primary,
        marginBottom: '0.3em'
      },
      '& > span': {
        fontSize: '1.3rem',
        fontWeight: 500,
        color: theme.gray700
      },
      '& > small': {
        fontSize: '1.1rem',
        color: theme.gray400,
        marginTop: '0.2em'
      }
    }
  };
};
export var selectedFile = function selectedFile(theme) {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: '0.6em',
    padding: '0.6em 1em',
    backgroundColor: theme.primaryLight,
    border: "1px solid ".concat(theme.primary),
    fontSize: '1.3rem',
    color: theme.primary,
    fontWeight: 500,
    flex: '1 1 200px',
    minWidth: 0,
    marginTop: '2.1em',
    '& .file-name': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    '& .file-remove': {
      cursor: 'pointer',
      flexShrink: 0,
      opacity: 0.6,
      transition: 'opacity 0.15s',
      '&:hover': {
        opacity: 1
      }
    }
  };
};
export var documentsList = function documentsList(theme) {
  return {
    '& .docs-title': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: '1em',
      '& h6': {
        fontSize: '1.2rem',
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
        color: theme.gray400
      },
      '& .docs-count': {
        fontSize: '1.1rem',
        color: theme.gray400
      }
    }
  };
};
export var documentItem = function documentItem(theme) {
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0.8em 1em',
    backgroundColor: theme.white,
    border: "1px solid ".concat(theme.gray100),
    marginBottom: '0.5em',
    transition: 'border-color 0.15s ease',
    '&:hover': {
      borderColor: theme.gray300
    },
    '& .doc-info': {
      display: 'flex',
      alignItems: 'center',
      gap: '0.8em',
      minWidth: 0,
      flex: 1,
      cursor: 'pointer',
      '& > i': {
        fontSize: '1.8rem',
        color: theme.primary,
        flexShrink: 0
      }
    },
    '& .doc-name': {
      fontSize: '1.3rem',
      fontWeight: 500,
      color: theme.gray700,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    '& .doc-actions': {
      display: 'flex',
      alignItems: 'center',
      gap: '0.4em',
      flexShrink: 0,
      marginLeft: '0.8em'
    },
    '& .doc-action-btn': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '2.8rem',
      height: '2.8rem',
      cursor: 'pointer',
      color: theme.gray400,
      fontSize: '1.5rem',
      transition: 'color 0.15s ease',
      '&:hover': {
        color: theme.primary
      }
    },
    '& .doc-delete:hover': {
      color: theme.error
    }
  };
};
export var footerActions = {
  display: 'flex',
  justifyContent: 'flex-end',
  paddingTop: '1em'
};